import React, { useEffect } from "react";
import IconBeneficiario from "../../Resources/svg/Icons/IconBeneficiario";
import { validateTextOnlyAlphanumeric, validatorField } from "../../Utils/validators";
import ErrorCustom from "../../Components/errorCustom";
import { Controller, useFormContext } from "react-hook-form";
import NumberFormat from "react-number-format";

interface Props {
  disableRemove: boolean;
  activitiesData: Array<any>;
  activity: Object;
  index: number;
  removeActivity: Function;
  count: number;
}

export const BusinessActivityForm = ({
  disableRemove,
  activitiesData,
  activity,
  index,
  removeActivity,
  count,
}: Props) => {
  const methods = useFormContext();
  const { register, errors, watch, setValue, control } = methods;

  const moneyTypeControl = activitiesData
  .flatMap((item) => item.childControls)
  .find((child) => child.metadata.placeholder === "Moneda");
  const amountControl = activitiesData
  .flatMap((item) => item.childControls)
  .find((child) => child.metadata.placeholder === "Monto");
  const activityTypeControl = activitiesData.find(
    (item) => item.metadata.placeholder === "Tipo de actividad"
  );

  const moneyTypeSk = Object.keys(activity)[0];
  const amountSk = Object.keys(activity)[1];
  const activityTypeSk = Object.keys(activity)[2];

  const remove = (e: any) => {
    e.preventDefault();
    if(disableRemove) return;
    removeActivity(index);
  }

  const addCommas = (num: any) =>
    num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const removeNonNumeric = (num: any) => num.toString().replace(/[^0-9]/g, "");

  return (
    <>
      <div
        className={`beneficiaryForm${index === 0 ? " first" : ""}`}
        style={{ position: "relative" }}
      >
        <div className="clientForm__beneficiary-box">
          <div className="clientForm__beneficiary-box-icon">
            <IconBeneficiario />
            <div className="clientForm__beneficiary">
              Actividad Empresarial {(index+1) + 1}
            </div>
          </div>
          {count > 0 && (
            <p
              className={`clientForm__eliminar ${disableRemove ? "disabled-action" : ""}`}
              onClick={(e) => {
                remove(e);
              }}
            >
              Eliminar
            </p>
          )}
        </div>
      </div>

      {activitiesData[0] && (
        <div className="question__control input-field">
          <div className="group-form">
            <div className="question__control input-field">
              {moneyTypeControl && (
                <select
                  name={moneyTypeSk}
                  id={moneyTypeSk}
                  ref={register({ validate: validatorField })}
                >
                  <option value={""} disabled selected>
                    {moneyTypeControl.metadata.placeholder}
                  </option>
                  {moneyTypeControl.metadata.options.map((option: any, idx: number) => (
                    <option value={option} key={idx}>
                      {option}
                    </option>
                  ))}
                </select>
              )}
              <ErrorCustom errors={errors} name={moneyTypeSk} />
            </div>

            <div className="clientForm__control input-field">
              <Controller
                as={NumberFormat}
                id={amountSk}
                name={amountSk}
                control={control}
                maxLength={amountControl.metadata.maxLength}
                rules={{
                  required: true,
                }}
              />
              <label
                htmlFor={
                  amountSk
                }
              >
                {amountControl.metadata.placeholder}
              </label>
              <ErrorCustom errors={errors} name={amountSk} />
            </div>
          </div>
        </div>
      )}

      {activitiesData[0] && (
        <div className="question__control input-field">
          <input
            id={activityTypeSk}
            name={activityTypeSk} 
            type="text"
            autoComplete="off"
            maxLength={activityTypeControl.metadata.maxLength} 
            ref={register({
              validate: {
                validatorField,
              },
            })}
          />
          <label htmlFor={activityTypeSk}>
            {activityTypeControl.metadata.placeholder}
          </label>
          <ErrorCustom errors={errors} name={activityTypeSk} />
        </div>
      )}
    </>
  )
}